export default {"src":"/_next/static/media/SpinalFractures.f186dcc3.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};